import angular from "angular";

angular
    .module('app')
    .component('rolesAndPermissions', {
        template: require('./roles-and-permissions.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, ErrorResponseParser, Notifier) {

    let $ctrl = this;


    $ctrl.$onInit = function () {
        $ctrl.role = $ctrl.resolve.role;
        $ctrl.permissions = $ctrl.resolve.permissions;
        $ctrl.permissions.forEach(function (permission) {
            permission.isSelected = checkPermissionIsSelected(permission);
        });

    };

    function checkPermissionIsSelected(permission) {
        for (let i = 0; i < $ctrl.role.permissions.length; i++) {
            if ($ctrl.role.permissions[i].id == permission.id) {
                return true;
            }
        }
        return false;
    }


    $ctrl.submit = function () {
        $ctrl.loading = true;


        let selectedPermissions = $ctrl.permissions.filter(v => v.isSelected);
        let selectedPermissionsIds = [];

        selectedPermissions.forEach(function (item) {
            selectedPermissionsIds.push(item.id);
        });



        $http.post(`/admin/roles/${$ctrl.role.id}/sync-permissions`, {permissions_ids: selectedPermissionsIds})
            .then(
                function (response) {
                    $ctrl.role.permissions = selectedPermissions;
                    $ctrl.close();

                    Notifier.success('Права успешно обновлены', 2);
                },
                function (error) {
                    $ctrl.loading = false;
                    Notifier.error('Произошла ошибка', 2);
                    ErrorResponseParser.parse(error);
                }
            );

    };

}
